import { SUPPORTED_RATIOS, SUPPORTED_PERCENTAGE_RATIOS } from "./utils";
import RatioBox from "./RatioBox";

export {
    RatioBox as default,
    SUPPORTED_RATIOS,
    SUPPORTED_PERCENTAGE_RATIOS,
};
